define('modules/player/media/central/central_media_collection',[
  'backbone',
  'jquery',
  '_',
  'session'
], function (Backbone, $, _, session) {
  'use strict';
  var Collection = Backbone.Collection.extend({

    default_params: {
      order_by: 'start_date',
      order: 'ASC'
    },

    params: {},

    initialize: function (opts) {
      _.extend(this, opts);
      this.resetParams();
    },

    parse: function (response) {
      if (response.metadata) {
        this.params = _.extend(this.params, response.metadata);
      }
      return response.data;
    },

    resetParams: function () {
      this.params = _.extend({}, this.default_params);
    },

    url: function () {
      if (this.zone_id) {
        return session.get('apiUrl') + 'players/' + this.player_id + '/central_media/' + this.zone_id + '?' + $.param(this.params || {});
      }
      else {
        return session.get('apiUrl') + 'players/' + this.player_id + '/central_media?' + $.param(this.params || {});
      }
    }
  });

  return Collection;
});

